module.exports = __webpack_public_path__ + "img/outline_new@2x.c86c99ed.png";